import { createContext } from "react";

const noop = (): never => {
  throw new Error("You forgot to wrap your component in <AuthProvider>.");
};

export const AuthMethod = {
  MWT: "MWT",
  COOKIE: "COOKIE",
  MWT_CODE: "MWT_CODE",
  FORM_COMPLETION: "FORM_COMPLETION",
} as const;

export type AuthMethodType = keyof typeof AuthMethod;

export type AuthContextProps = {
  isLoading: boolean;
  isAuthenticated: boolean;
  token?: string;
  authMethod?: AuthMethodType;
  setAuthMethod: (authMethod: AuthMethodType) => void;
  setToken: (token?: string) => void;
  logout: () => void;
};

export const AuthContext = createContext<AuthContextProps>({
  isLoading: true,
  isAuthenticated: false,
  logout: noop,
  setAuthMethod: noop,
  setToken: noop,
});
